import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'

import PreUnderwritingContainer, {PreUnderwritingContainerProps} from './PreUnderwritingContainer'
import {
  selectCompanyActivationStatus,
  selectCompanyIsLocked,
  selectCompanyExternalId,
} from '../../../data/company'
import {ROUTE_ONBOARDING} from '../../../routes/constants'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  PreUnderwritingContainerProps,
  'activationStatus' | 'isCompanyLocked' | 'companyExternalId'
> => ({
  activationStatus: selectCompanyActivationStatus(state) as string,
  isCompanyLocked: selectCompanyIsLocked(state),
  companyExternalId: selectCompanyExternalId(state) || '',
})

const mapDispatchToProps = {
  redirectToOnboarding: (): any => aPush(ROUTE_ONBOARDING),
}

export default connect(mapStateToProps, mapDispatchToProps)(PreUnderwritingContainer)
